import { render, staticRenderFns } from "./MitDocumentsPage.vue?vue&type=template&id=2a037978&scoped=true"
import script from "./MitDocumentsPage.vue?vue&type=script&lang=js"
export * from "./MitDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./MitDocumentsPage.vue?vue&type=style&index=0&id=2a037978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a037978",
  null
  
)

export default component.exports